module.exports = __webpack_public_path__ + "img/sticker-mule.2d1fece7.svg";